import React from 'react';
import { Zap, Shield, TrendingUp, Users } from 'lucide-react';
import { FadeUp, EYEBROW, GRAD_TEXT } from './shared';

const featureData = [
  { icon: <Zap size={20} strokeWidth={2} />, title: 'AI-Powered Analysis', desc: 'GPT-5.2 reads your CV and maps your qualifications to immigration rules in real time.' },
  { icon: <Shield size={20} strokeWidth={2} />, title: 'Real Immigration Rules', desc: 'Backed by official scoring systems — Canada CRS, Australia Points Test, UK PBS, and more.' },
  { icon: <TrendingUp size={20} strokeWidth={2} />, title: 'Personalised Roadmap', desc: 'Not just scores — actionable next steps tailored to your profile and strongest matches.' },
  { icon: <Users size={20} strokeWidth={2} />, title: 'Expert Consultation', desc: 'Connect with Axpats licensed migration consultants to turn your results into a plan.' },
];

const Features = () => (
  <section style={{ padding: '0 1.5rem 7rem', maxWidth: '1024px', margin: '0 auto' }}>
    <FadeUp>
      <div style={{ marginBottom: '3rem' }}>
        <span style={EYEBROW}>Why Axpats</span>
        <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(1.5rem, 3vw, 2.25rem)', fontWeight: 800, color: '#302B2C', letterSpacing: '-0.03em', lineHeight: 1.05, marginTop: '0.75rem' }}>
          Built for clarity, <span style={GRAD_TEXT}>not confusion</span>
        </h2>
      </div>
    </FadeUp>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
      {featureData.map((f, i) => (
        <FadeUp key={f.title} delay={i * 0.1}>
          <div data-testid={`feature-card-${i}`} style={{
            padding: '2rem', background: '#fff',
            border: '1px solid rgba(48,43,44,0.1)', borderRadius: '2px',
            transition: 'border-color 0.3s, transform 0.3s, box-shadow 0.3s', height: '100%',
          }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(246,116,37,0.35)'; e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 20px 40px -12px rgba(246,116,37,0.18)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(48,43,44,0.1)'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div style={{
              width: '40px', height: '40px', borderRadius: '2px', background: 'rgba(246,116,37,0.08)',
              border: '1px solid rgba(246,116,37,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#F67425', marginBottom: '1rem',
            }}>{f.icon}</div>
            <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1rem', fontWeight: 800, color: '#302B2C', marginBottom: '0.5rem' }}>{f.title}</h3>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '0.875rem', color: 'rgba(48,43,44,0.72)', lineHeight: 1.6, margin: 0 }}>{f.desc}</p>
          </div>
        </FadeUp>
      ))}
    </div>
  </section>
);

export default Features;
